<template>
  <div class="model_add_simcard">
    <div class="model_add_simcard__header">
      <h4 class="title">
        {{ translate("client_request.simcard_list.add_simcard") }}
      </h4>
    </div>

    <div class="model_add_simcard__body">
      <div class="line">
          <fg-input
              v-model="data.iccid"
              type="text"
              :label="translate('client_request.simcard_list.iccid')"
              :placeholder="translate('client_request.simcard_list.iccid')"
          />
      </div>
      <div class="line">
        <div class="text_wrap">
          <div class="form-group">
            <label>{{ translate('client_request.simcard_list.comment') }}</label>
            <textarea class="input_text" name="equipment" v-model="data.comment" rows="3" />
          </div>
        </div>
      </div>
    </div>
    <div class="model_add_simcard__footer">
      <span
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="save_new_simcard"
      >
        {{ translate('btn.edit') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>


export default {
  name: 'ClientRequestAddSimcard',
  props:[
    "client_request_id"
  ],
  components: { },
  data () {
    return {
      data: {
        iccid: "",
        comment: ""
      },
    }
  },

  methods: {
    save_new_simcard(){
      this.$http.v1.addSimcardClientRequest(this.client_request_id, this.data, (response) => {
        this.global_notify('info', this.translate('client_order.saved_success'))
        this.update()
      })
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_add_simcard{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      height: 100%;
      .line{
        margin-bottom: 10px;
      }
    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
